import styled from "styled-components";

const StyledNavbar = styled.header`

  display: block;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: auto;
  background-color: ${props => props.scrolled100 ? 'white' : 'transparent'};
  padding-top: .5rem;
  padding-bottom: .5rem;
  box-shadow: ${props => props.scrolled100 ? '0 1px 11px 0 rgba(0, 0, 0, 0.21)' : null};
  z-index: 1000;

  /****************************/
  /*          Brand           */
  /****************************/

  .nav_brand {
    text-decoration: none;
  }

  .logo {
    display: block;
    padding-top: .5rem;
    padding-bottom: .5rem;
    font-weight: 700;
    color: ${props => props.scrolled100 ? 'rgba(0, 123, 255, 0.9)' : 'rgba(255, 255, 255, 0.9)'};
    font-size: 2rem;
  }

  @media screen and (max-width: 479px) {
    .logo {
      font-size: 1.75rem;
    }
  }

  /****************************/
  /*        Nav Menu          */
  /****************************/

  .nav_list {
    display: flex;
    margin: 0; //see if I can remove
    padding-left: 0; //see if I can remove
    flex-direction: row;
    grid-column-gap: 1rem;
    grid-row-gap: 1rem;
    list-style-type: none;
  }

  .nav_item {
    padding: 0.75rem;
  }

  .nav_link {
    color: grey;
    font-size: 1.5rem;
    text-decoration: none; //can I remove this
  }

  .nav_link:hover {
    color: ${props => props.scrolled100 ? '#007BFF' : '#FFFFFF'};
  }

  .nav_link:focus {
    color: ${props => props.scrolled100 ? '#007BFF' : '#FFFFFF'};
  }
  

  @media screen and (max-width: 991px) {
    .nav_list {
      flex-direction: column;
      position: absolute;
      overflow: hidden;
      top: 100%;
      left: 0;
      right: 0;
      background-color: #c8c8c8;
      //margin: 0;     //can I remove
      transition: all 0.3s ease-in; //need to figure this out
    }

    .nav_list:not(.show) {
      display: none;
    }
  }

  /****************************/
  /*      Menu Button         */
  /****************************/

  .menu-button {
    display: none;
  }

  @media screen and (max-width: 991px) {
    .menu-button {
      display: block;
      padding: 1rem;
      border-radius: 0.5rem;
      margin-left: auto;
      border: none;
      background-color: transparent;
    }

    .menu-button:active {
      background-color: #a1a1a1;
    }

    /****************************/
    /* Font Awesome Button Icon */
    /****************************/
    .nav_icon {
      font-family: 'Font Awesome 6 Free', sans-serif;
      color: grey;
      font-size: 2rem;
    }

    .nav_icon:hover {
      color: ${props => props.scrolled100 ? '#007BFF' : '#FFFFFF'};
    }

  }
  @media screen and (max-width: 479px) {
    .nav_icon {
      font-size: 1.75rem;
    }
  }
`

export default StyledNavbar;
